import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';

import { USER_SEGMENT } from './query';
import type { UserSegmentResponse, Query } from '~types';

type ReturnedProperties = 'data' | 'loading' | 'errors';

export type UseUserSegmentResponse = Pick<
  UseQueryResult<UserSegmentResponse>,
  ReturnedProperties
>;

const useUserSegment = (disabled?: boolean): UseUserSegmentResponse => {
  const queryResult = useQuery<Pick<Query, 'userSegment'>>(USER_SEGMENT, {
    skip: disabled,
  });

  const { data, loading, errors } = queryResult;

  useLogFrontendApiError(queryResult);

  return {
    data: data?.userSegment ?? null,
    loading,
    errors,
  };
};

export default useUserSegment;
